var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDsaElectron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22.7363,
    height: 22.7293,
    viewBox: "0 0 22.7363 22.7293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "electron 1",
    clipPath: "url(#clip0_0_14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.6424 0.98996C17.9372 0.98996 16.5517 2.37858 16.5517 4.08327C16.5517 4.4029 16.605 4.70832 16.6974 4.99954L13.3651 7.20144C12.7114 6.56573 11.8162 6.16442 10.8179 6.16442C9.05939 6.16442 7.59219 7.39322 7.28667 9.00557H4.85317C4.57607 7.94369 3.61688 7.15882 2.46941 7.15882C1.10878 7.15882 0.000389024 8.26332 0.000389024 9.62708C0.000389024 10.9908 1.10878 12.0989 2.47296 12.0989C3.61689 12.0989 4.58318 11.314 4.85673 10.2521H7.29022C7.46074 11.1506 7.99363 11.9284 8.73611 12.4363L7.15167 15.6574C6.89944 15.59 6.63655 15.5509 6.37011 15.5509C4.66489 15.5509 3.27584 16.9395 3.27584 18.6442C3.27584 20.3489 4.66489 21.7375 6.37011 21.7375C8.07534 21.7375 9.46438 20.3489 9.46438 18.6442C9.46438 17.6569 8.99189 16.7868 8.26717 16.2186L9.87293 12.9654C10.1749 13.0471 10.4946 13.0933 10.8215 13.0933C11.6066 13.0933 12.3348 12.8447 12.9317 12.4327L14.7719 14.2653C14.5587 14.6311 14.4273 15.0572 14.4273 15.5083C14.4273 16.872 15.5357 17.9801 16.8999 17.9801C18.2605 17.9801 19.3724 16.872 19.3724 15.5083C19.3724 14.1481 18.2605 13.0365 16.8999 13.0365C16.3705 13.0365 15.8838 13.2105 15.4824 13.4946L13.6884 11.7153C13.898 11.449 14.0685 11.1542 14.1928 10.831C14.3385 10.4581 14.4166 10.0497 14.4166 9.62708C14.4166 9.12277 14.2958 8.64688 14.0934 8.21715L17.312 6.08984C17.8768 6.7504 18.7117 7.17658 19.646 7.17658C21.3512 7.17658 22.7403 5.78796 22.7403 4.08327C22.7403 2.37858 21.3477 0.98996 19.6424 0.98996Z",
    fill: "#F8FAFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.7363,
    height: 22.7293,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsaElectron);
export default __webpack_public_path__ + "static/media/dsaElectron.e0468def9c70ca10f4d9d93fdad60f07.svg";
export { ForwardRef as ReactComponent };